import * as React from 'react';
import clsx from 'clsx';
import voiceIcon from '@/assets/images/svg/voice_icon.svg';

interface VoiceButtonProps {
  onClick?: () => void;
  onTouchStart?: (e: TouchEvent) => void;
  disabled?: boolean;
}

export const VoiceButton: React.FC<VoiceButtonProps> = ({ onClick, onTouchStart, disabled }) => {
  const btnRef = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
    const el = btnRef.current;
    if (!el || !onTouchStart) return;
    const handler = (e: TouchEvent) => onTouchStart(e);
    el.addEventListener('touchstart', handler, { passive: false });
    return () => el.removeEventListener('touchstart', handler);
  }, [onTouchStart]);

  return (
    <button
      ref={btnRef}
      type='button'
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        'absolute right-4 top-1/2 -translate-y-1/2',
        // Dimensions & shape
        'flex h-[31px] w-[78px] items-center justify-center rounded-20',
        // Appearance: #464646 background, lighter on hover
        'bg-gray-700 hover:bg-gray-800',
        'transition-colors',
        'disabled:cursor-not-allowed disabled:opacity-50'
      )}
    >
      <div className='flex items-center gap-1.5'>
        <img src={voiceIcon} alt='Voice' className='size-4' />
        <span
          className={clsx(
            'font-sans text-12 font-normal leading-160 tracking-[-0.02em] text-white'
          )}
        >
          Voice
        </span>
      </div>
    </button>
  );
};
